import type { ProjectContentData } from '../types';
import { PROJECT_CONTENT_TAB_TYPE } from '../types';
import { tableOfContentTab } from './data';

export const stormTrade: ProjectContentData = {
  id: 'storm-trade',
  tabs: [
    {
      id: 'description',
      label: 'Description',
      type: PROJECT_CONTENT_TAB_TYPE.TABLE_OF_CONTENT,
      content: tableOfContentTab,
    },
    {
      id: 'key-metrics',
      label: 'Key Metrics',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      content: [
        {
          id: 'ton',
          value: 'TON',
          name: 'Blockchain Network',
          description: (
            <span>
              Indicates the blockchain
              <br />
              network for this token.
            </span>
          ),
        },
        {
          id: 'total-supply',
          value: '1.000.000.000',
          name: 'Total Supply',
          description: <span>Displays the total token supply.</span>,
        },
        {
          id: 'initial-circulation-supply',
          value: '43.587.597',
          name: 'Initial Circulating Supply',
          description: (
            <span>
              Shows the circulating supply at the
              <br />
              Token Generation Event (TGE).
            </span>
          ),
        },
        {
          id: 'initial-market-cap',
          value: '523.051',
          name: 'Initial Market Cap',
          description: (
            <span>
              Reflects the initial
              <br />
              market cap at the TGE.
            </span>
          ),
        },
      ],
    },
    {
      id: 'deal-terms',
      label: 'Deal Terms',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      content: [
        {
          id: 'total-raising-goal',
          name: 'Total Raising Goal',
          value: '$150,000',
          description: (
            <span>
              Total funds targeted to be
              <br />
              raised across all pools in this Token Sale.
            </span>
          ),
        },
        {
          id: 'eat-price',
          name: 'EAT Price',
          value: '$0.012',
          description: (
            <span>
              Price per token
              <br />
              during the Token Sale.
            </span>
          ),
        },
        {
          id: 'allocation-size',
          name: 'Allocation Size',
          value: '$50-200',
          description: (
            <span>
              Range of allocation sizes for participation in the FCFS Pools. The allocation sizes in
              the Pro-Rata Pools will be determined based on the relative buying power of the entire
              pool.
            </span>
          ),
        },
        {
          id: 'accepted-payment',
          name: 'Accepted Payment',
          value: 'USDT (BEP20)',
          description: (
            <span>
              Accepted stable coin and network
              <br />
              for Token Sale participation.
            </span>
          ),
        },
      ],
    },
    {
      id: 'vesting',
      label: 'Vesting',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      content: [
        {
          id: 'tge',
          value: '15 %',
          name: 'At TGE',
          description: (
            <span>
              Percentage of tokens
              <br />
              claimable/distributed at the TGE.
            </span>
          ),
        },
        {
          id: 'cliff',
          name: 'Cliff',
          value: '0 Months',
          description: (
            <span>
              Months until the next
              <br />
              token distribution post-TGE.
            </span>
          ),
        },
        {
          id: 'linear-vesting',
          name: 'Linear Vesting',
          value: '6 Months',
          description: (
            <span>
              Token distribution
              <br />
              schedule post-cliff period.
            </span>
          ),
        },
        {
          id: 'distribution-method',
          value: 'Airdrop by Storm Trade',
          name: 'Distribution Method',
          description: (
            <span>
              Information on token
              <br />
              distribution/claim process.
            </span>
          ),
        },
      ],
    },
    {
      id: 'ido',
      label: 'EAT Schedule',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      content: [
        {
          id: 'sale-start',
          value: '29.07.24',
          name: 'Sale Start',
          description: <span>Start date of the Token Sale.</span>,
        },
        {
          id: 'sale-end',
          value: '02.08.24',
          name: 'Sale End',
          description: <span>End date of the Token Sale.</span>,
        },
        {
          id: 'otc-date',
          name: 'OTC Date',
          value: '05.08.24',
          description: (
            <span>
              Date when the token sale allocations will be available for trading on our OTC
              Marketplace until the TGE.
            </span>
          ),
        },
      ],
    },
  ],
};
